import { ROUTES } from './config'
import { Icons } from './icons'

export const menuVoices = [
  {
    id: 1,
    label: 'Dashboard',
    icon: Icons.dashboardIcon,
    link: ROUTES.dashboard
  },
  {
    id: 2,
    label: 'Viaggi',
    icon: Icons.tripsIcon,
    link: ROUTES.trips
  },
  {
    id: 3,
    label: 'Veicoli',
    icon: Icons.vehicleIcon,
    link: ROUTES.vehicles
  },
  {
    id: 4,
    label: 'Dispositivi',
    icon: Icons.deviceIcon,
    link: ROUTES.devices
  }
]
